import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import useVuelidate from "@vuelidate/core";
  import { email, required } from "@vuelidate/validators";
  import { useStore } from "vuex";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ShareMapModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    estateId: {
      type: String,
      required: true,
    },
    estateTitle: {
      type: String,
      required: true,
    },
  },
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const store = useStore();
  const emits = __emit;
  const props = __props;
  const form = reactive({
    email: "",
  });
  const loading = ref(false);
  const rules = {
    email: { required, email },
  };
  const v$ = useVuelidate(rules, form);

  function close() {
    emits("close");
    clear();
  }

  function send() {
    v$.value.$touch();

    if (v$.value.$invalid) {
      return;
    }

    loading.value = true;
    store
      .dispatch("estate/sendEstateMap", {
        email: form.email,
        estateId: props.estateId,
        estateTitle: props.estateTitle,
      })
      .then(() => {
        close();
      })
      .finally(() => (loading.value = false));
  }

  function clear() {
    form.email = "";
    resetVuelidateErrors(v$);
    loading.value = false;
  }

const __returned__ = { store, emits, props, form, loading, rules, v$, close, send, clear, reactive, ref, Modal, get useVuelidate() { return useVuelidate }, get email() { return email }, get required() { return required }, get useStore() { return useStore }, get resetVuelidateErrors() { return resetVuelidateErrors } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})